import React, { useContext, useEffect, useState, useRef } from 'react';
  declare global {
    interface Window {
        Trustpilot:any;
    }
}
const TrustBox = () => {
  const ref = useRef(null);
  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);
  return (
    <div
    ref={ref}
    className="trustpilot-widget"
    data-locale="en-US"
    data-template-id="53aa8807dec7e10d38f59f32"
    data-businessunit-id="5d485c0eaf4c150001452791"
    data-style-height="150px"
    data-style-width="100%"
    data-theme="light"
>
    <a href="https://www.trustpilot.com/review/pdfsimpli.com" rel="noopener">
        Trustpilot
    </a>
</div>
  );
};
export default TrustBox;